<template>
  <!-- 合成 -->
    <Tabs :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }"  @on-click="waresList(1)"   >
      <TabPane label="限时活动" > <div style="margin: 10px">
        <div  :class="{ 'knapsack': electronicEquipment, 'knapsack2': !electronicEquipment }">
          <Poptip transfer
                  trigger="hover"
                  v-for="item in synthesisList4"
                  :key="item.syntheticName"
                  :title="item.syntheticName"
          >
            <p
              style="white-space: nowrap; height: 24px;"
              :style="{ color: distinguishColor(item.color) }"
            >
              <Tag  color="primary" size="medium" style="margin: 8px" v-if="!isActive"> {{ item.syntheticName }}</Tag>
              <span  style="color: #078599e0" v-if="isActive"> {{ item.syntheticName }} * {{ item.syntheticNum }}</span>
              <Button transfer
                @click.prevent="synthesisItem(item)"
                size="small"
                type="info" ghost
              >
                合成
              </Button>
              <Button transfer
                @click.prevent="synthesisItem1(item)"
                size="small"
                type="info"
              >
                批量合成
              </Button>
            </p>
            <div slot="content" >
              <p v-if="item.syntheticDesci">
                物品描述: {{ item.syntheticDesci }}
              </p>
              <p v-if="item.syntheticNum || item.syntheticNum==0">
                物品限制次数: {{ item.syntheticNum }}
              </p>
              <p v-if="item.syntheticExp">
                消耗经验: {{ item.syntheticExp }}
              </p>
              <p v-if="item.syntheticMoney">
                消耗金币: {{ item.syntheticMoney }}
              </p>
              <p v-if="item.syntheticRealm">
                最低境界:
                <span style="color: rgb(45, 196, 255)">
                {{ item.syntheticRealm }}
              </span>
              </p>
              <p v-if="item.materOneName">
                {{ item.materOneName }}: 需要
                {{ item.materOneNum }}
              </p>
              <p v-if="item.materTwoName">
                {{ item.materTwoName }}: 需要
                {{ item.materTwoNum }}
              </p>
              <p v-if="item.materThreeName">
                {{ item.materThreeName }}: 需要
                {{ item.materThreeNum }}
              </p>
              <p v-if="item.coin">
                需要 {{ item.coninType == 0 ? "金币" : "灵石" }}
                {{ item.coin }}
              </p>
            </div>
          </Poptip>
        </div>
      </div></TabPane>
      <TabPane label="道具/箱">
        <div style="margin: 10px">
          <div :class="{ 'knapsack': electronicEquipment, 'knapsack2': !electronicEquipment }" >
            <Poptip transfer
                    trigger="hover"
              v-for="item in synthesisList1"
              :key="item.syntheticName"
              :title="item.syntheticName"
            >
              <p
                style="white-space: nowrap; height: 24px;"
                :style="{ color: distinguishColor(item.color) }"
              >
                <Tag  color="success"  size="medium"  style="margin: 8px" v-if="!isActive"> {{ item.syntheticName }}</Tag>
                <span  style="color: #04ad80e0" v-if="isActive"> {{ item.syntheticName }} * {{ item.syntheticNum }}</span>
                <Button
                  @click.prevent="synthesisItem(item)"
                  size="small"
                  type="info" ghost
                >
                  合成
                </Button>
                <Button
                  @click.prevent="synthesisItem1(item)"
                  size="small"
                  type="info"
                >
                  批量合成
                </Button>
              </p>
              <div slot="content" >
                <p v-if="item.syntheticDesci">
                  物品描述: {{ item.syntheticDesci }}
                </p>
                <p v-if="item.syntheticNum || item.syntheticNum==0">
                  物品限制次数: {{ item.syntheticNum }}
                </p>
                <p v-if="item.syntheticExp">
                  消耗经验: {{ item.syntheticExp }}
                </p>
                <p v-if="item.syntheticMoney">
                  消耗金币: {{ item.syntheticMoney }}
                </p>
                <p v-if="item.syntheticRealm">
                  最低境界:
                  <span style="color: rgb(45, 196, 255)">
                {{ item.syntheticRealm }}
              </span>
                </p>
                <p v-if="item.materOneName">
                  {{ item.materOneName }}: 需要
                  {{ item.materOneNum }}
                </p>
                <p v-if="item.materTwoName">
                  {{ item.materTwoName }}: 需要
                  {{ item.materTwoNum }}
                </p>
                <p v-if="item.materThreeName">
                  {{ item.materThreeName }}: 需要
                  {{ item.materThreeNum }}
                </p>
                <p v-if="item.coin">
                  需要 {{ item.coninType == 0 ? "金币" : "灵石" }}
                  {{ item.coin }}
                </p>
              </div>
            </Poptip>
          </div>
        </div>
      </TabPane>
      <TabPane label="材料">
        <div style="margin: 10px">
        <div :class="{ 'knapsack': electronicEquipment, 'knapsack2': !electronicEquipment }">
          <Poptip transfer
                  trigger="hover"
                  v-for="item in synthesisList2"
                  :key="item.syntheticName"
                  :title="item.syntheticName"
          >
            <p
              style="white-space: nowrap; height: 24px;"
              :style="{ color: distinguishColor(item.color) }"
            >
              <Tag color="warning"  size="medium" style="margin: 8px" v-if="!isActive"> {{ item.syntheticName }}</Tag>
              <span  style="color: #d88228" v-if="isActive"> {{ item.syntheticName }} * {{ item.syntheticNum }}</span>
              <Button
                @click.prevent="synthesisItem(item)"
                size="small"
                type="info" ghost
              >
                合成
              </Button>
              <Button
                @click.prevent="synthesisItem1(item)"
                size="small"
                type="info"
              >
                批量合成
              </Button>
            </p>
            <div slot="content" >
              <p v-if="item.syntheticDesci">
                物品描述: {{ item.syntheticDesci }}
              </p>
              <p v-if="item.syntheticNum  || item.syntheticNum==0">
                物品限制次数: {{ item.syntheticNum }}
              </p>
              <p v-if="item.syntheticExp">
                消耗经验: {{ item.syntheticExp }}
              </p>
              <p v-if="item.syntheticMoney">
                消耗金币: {{ item.syntheticMoney }}
              </p>
              <p v-if="item.syntheticRealm">
               最低境界:
                <span style="color: rgb(45, 196, 255)">
                {{ item.syntheticRealm }}
              </span>
              </p>
              <p v-if="item.materOneName">
                {{ item.materOneName }}: 需要
                {{ item.materOneNum }}
              </p>
              <p v-if="item.materTwoName">
                {{ item.materTwoName }}: 需要
                {{ item.materTwoNum }}
              </p>
              <p v-if="item.materThreeName">
                {{ item.materThreeName }}: 需要
                {{ item.materThreeNum }}
              </p>
              <p v-if="item.coin">
                需要 {{ item.coninType == 0 ? "金币" : "灵石" }}
                {{ item.coin }}
              </p>
            </div>
          </Poptip>
        </div>
      </div></TabPane>
      <TabPane label="秘籍书"> <div style="margin: 10px">
        <div :class="{ 'knapsack': electronicEquipment, 'knapsack2': !electronicEquipment }">
          <Poptip transfer
                  trigger="hover"
                  v-for="item in synthesisList3"
                  :key="item.syntheticName"
                  :title="item.syntheticName"
          >
            <p
              style="white-space: nowrap; height: 24px;"
              :style="{ color: distinguishColor(item.color) }"
            >
              <Tag   style="margin: 8px" v-if="!isActive"> {{ item.syntheticName }}</Tag>
              <span  style="color: #9e0e42e0" v-if="isActive"> {{ item.syntheticName }} * {{ item.syntheticNum }}</span>
              <Button
                @click.prevent="synthesisItem(item)"
                size="small"
                type="info" ghost
              >
                合成
              </Button>
              <Button
                @click.prevent="synthesisItem1(item)"
                size="small"
                type="info"
              >
                批量合成
              </Button>
            </p>
            <div slot="content">
              <p v-if="item.syntheticDesci">
                物品描述: {{ item.syntheticDesci }}
              </p>
              <p v-if="item.syntheticNum  || item.syntheticNum==0">
                物品限制次数: {{ item.syntheticNum }}
              </p>
              <p v-if="item.syntheticExp">
                消耗经验: {{ item.syntheticExp }}
              </p>
              <p v-if="item.syntheticMoney">
                消耗金币: {{ item.syntheticMoney }}
              </p>
              <p v-if="item.syntheticRealm">
                最低境界:
                <span style="color: rgb(45, 196, 255)">
                {{ item.syntheticRealm }}
              </span>
              </p>
              <p v-if="item.materOneName">
                {{ item.materOneName }}: 需要
                {{ item.materOneNum }}
              </p>
              <p v-if="item.materTwoName">
                {{ item.materTwoName }}: 需要
                {{ item.materTwoNum }}
              </p>
              <p v-if="item.materThreeName">
                {{ item.materThreeName }}: 需要
                {{ item.materThreeNum }}
              </p>
              <p v-if="item.coin">
                需要 {{ item.coninType == 0 ? "金币" : "灵石" }}
                {{ item.coin }}
              </p>
            </div>
          </Poptip>
        </div>
      </div></TabPane>
      <!-- 批量合成弹出框 -->
      <Modal transfer
        width="620"
        title="批量合成"
        v-model="batchEject"
        @on-ok="bulkPurchase()"
        :styles="{ top: '100px' }"
      >
        <div>
          <Input v-model="batchNum" type="Number"  placeholder="请输入数量" />
        </div>
      </Modal>
    </Tabs>
</template>
<script>
export default {
  name: "playersList",
  data() {
    return {
      synthesisList: [], // 合成列表
      synthesisList1: [], // 合成列表
      synthesisList2: [], // 合成列表
      synthesisList3: [], // 合成列表
      synthesisList4: [], // 合成列表
      syntheticId: "",
      screenWidth:"420px",
      electronicEquipment: false, // 电子设备
      isActive:false, // 切换主体
      batchEject: false,
      batchNum: 1
    };
  },
  created() {
    // 判断是手机端还是pc端
    //this.screenWidth = window.innerWidth;
    const screenWidth = window.innerWidth;
    this.screenWidth=screenWidth+"px";
    if (this._isMobile()) {
      this.electronicEquipment = false;
    } else {
      this.electronicEquipment = true;
    }
    //this.waresList();
    const theme = window.localStorage.getItem("isTheme");
    if(theme === "black"){
      this.isActive=true;
    }else{
      this.isActive=false;
    }
  },
  methods: {
    // 返回品质颜色
    distinguishColor(color) {
      if (color == 1) {
        return "#000";
      } else if (color == 2) {
        return "#c5c52f";
      } else if (color == 3) {
        return "#049c04";
      } else if (color == 4) {
        return "#005aff";
      } else if (color == 5) {
        return "#ff00e0";
      } else if (color == 6) {
        return "#ff0000";
      } else if (color == 7) {
        return "#ff8c00";
      } else {
        return "#ff8c00";
      }
    },
    // 获取合成列表
    waresList(value) {
      if(value !== 1 ||  this.synthesisList.length === 0){
        this.$http.post("/gameRealm/getSyntheticList?charaId="+
          this.getCookie("charaId")
        ).then((res) => {
          this.synthesisList = res.data.data;
          this.synthesisList1 = [];
          this.synthesisList2 = [];
          this.synthesisList3= [];
          this.synthesisList4= [];
          for (var i = 0; i < this.synthesisList.length; i++) {
            if ( 2 == this.synthesisList[i].syntheticType) {
              this.synthesisList1.push(this.synthesisList[i]);
            }else if ( 3 == this.synthesisList[i].syntheticType) {
              this.synthesisList2.push(this.synthesisList[i]);
            }else  if ( 4 == this.synthesisList[i].syntheticType) {
              this.synthesisList3.push(this.synthesisList[i]);
            }else  if ( 1 == this.synthesisList[i].syntheticType) {
              this.synthesisList4.push(this.synthesisList[i]);
            }
          }
        });
      }
    },
    // 判断是手机端还是pc端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 合成
    synthesisItem(item) {
      this.$http
        .post(
          "	/gameRealm/breakThroughTheSynthetic?charaId=" +
            this.getCookie("charaId") +
            "&syntheticId=" +
            item.syntheticId +
            "&syntheticNum=" +
            1
        )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});
          this.waresList(2);
          this.$bus.$emit("synthesisMsg", "合成发送过来的");
        })
        .catch((err) => {
          this.$Notice.error({title:"合成失败,请联系管理员"});
        });
    },
    // 合成
    synthesisItem1(item) {
      this.batchEject = true;
      this.syntheticId = item.syntheticId
    },
    bulkPurchase() {
      this.$http
        .post(
          "	/gameRealm/breakThroughTheSynthetic?charaId=" +
            this.getCookie("charaId") +
            "&syntheticId=" +
            this.syntheticId +
            "&syntheticNum=" +
            this.batchNum
        )
        .then((res) => {
          console.log(res)
          this.$Notice.warning({title:res.data.msg});
          this.$bus.$emit("synthesisMsg1", "合成发送过来的");
        })
        .catch((err) => {
          this.$Notice.warning({title:"合成失败,请联系管理员"});
        });
    }
  },
};
</script>

<style scoped>
/* knapsack 储物空间 和合成共用的 */
.knapsack {
  /* max-height: 516px; */
}
.knapsack2 {
 /* max-width: 426px;*/
  /* max-height: 516px; */
}
.knapsack2 /deep/ .ivu-poptip {
  width: 95%;
}
.knapsack /deep/ .ivu-poptip-popper {
  pointer-events: none;
  z-index: 9;
}
.knapsack /deep/ .ivu-poptip {
  width: 25%;
}
.knapsack /deep/ .ivu-poptip p button {
  visibility: hidden;
  height: 22px;
}
.knapsack /deep/ .ivu-poptip p:hover {
  z-index: 9;
  position: relative;
}
.knapsack /deep/ .ivu-poptip p:hover button {
  visibility: visible;
}
.blackBackGroup{
  background-color: #151728;
  color: #9c9cab;
}
.blackBackGroup2{
  background-color: #ffffff;
  color: black;
}
/* 为了给提示设置 颜色 */
 /deep/  .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-inner {
  background-color: #373e57 !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.blackBackGroup /deep/  .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-arrow:after {
  border-top-color: rgba(70, 76, 91, 0.9);
}
.blackBackGroup /deep/  .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title {
  background: #373e57 !important;
}
.blackBackGroup /deep/  .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title-inner {
  background: #373e57 !important;
  color: #fff !important;
}
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-body {
  /* color: #fff;*/
  background: #373e57 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/synthesis.vue